import React, { useContext } from 'react';
import Title from 'components/Title';
import TitleImages from 'components/TitleImages';
import Hedgehog from 'assets/Images/hedgehog.svg';
import {
  Wrapper,
  Box,
  Imagebox,
  Image,
  Text,
  Item,
  ItemExternal
} from './WidgetItemsGrid.style';
import { useTheme } from 'ThemeContext';
import IMAGE_PLACEHOLDER from 'assets/Images/placeholder-50x50.png';
import { AppSettingsContext } from 'AppSettingsContext';

function WidgetItemsGrid({ title = '', data = [] }) {
  const theme = useTheme();
  const [appSettings] = useContext(AppSettingsContext);

  const renderItemInner = (item, key) => {
    const regExp = new RegExp('(.*)(.jpg|.jpeg|.png)$');
    let currentImage = item.thumbnail || item.image;
    let currentImageMatch;
    if (currentImage) {
      currentImageMatch = currentImage.match(regExp);
      if (currentImageMatch && currentImageMatch[1] && currentImageMatch[2])
        currentImage = `${currentImageMatch[1]}_${theme.widgetItemsGrid.image.width}x${theme.widgetItemsGrid.image.height}${currentImageMatch[2]}`;
    }
    return (
      <>
        <Imagebox theme={theme.widgetItemsGrid.imagebox}>
          <Image
            theme={theme.widgetItemsGrid.image}
            src={currentImage || IMAGE_PLACEHOLDER}
            loading='lazy'
            alt={item.title}
          />
        </Imagebox>
        <Text theme={theme.widgetItemsGrid.text}>{item.title}</Text>
      </>
    );
  };

  return (
    <Wrapper theme={theme.widgetItemsGrid.wrapper}>
      {appSettings.theme === 4 ? (
        <TitleImages title={title} imageSrc={Hedgehog} theme={theme.title} />
      ) : (
        <Title title={title} />
      )}
      <Box theme={theme.widgetItemsGrid.box}>
        {data &&
          data.map((item, key) => (
            <>
              {(item.slug && /(http(s?)):\/\//gi.test(item.slug)) ||
              (item.url && /(http(s?)):\/\//gi.test(item.url)) ||
              item.url_outside ? (
                <ItemExternal
                  theme={theme.widgetItemsGrid.item}
                  href={item.slug || item.url || item.url_outside}
                  target={
                    item._blank || item.url_blank || item.url_outside_blank
                      ? '_blank'
                      : '' || item.target || ''
                  }
                  rel={
                    item.nofollow ||
                    item.url_nofollow ||
                    item.url_outside_nofollow
                      ? 'nofollow'
                      : '' || item.rel || ''
                  }
                >
                  {renderItemInner(item, key)}
                </ItemExternal>
              ) : (
                <Item
                  theme={theme.widgetItemsGrid.item}
                  withoutHover={item.slug ? false : true}
                  smooth
                  to={
                    item.slug && (item.slug[0] === '/' || item.slug[0] === '#')
                      ? item.slug
                      : `/${item.slug}`
                  }
                >
                  {renderItemInner(item, key)}
                </Item>
              )}
            </>
          ))}
      </Box>
    </Wrapper>
  );
}

export default WidgetItemsGrid;
